export default "__VITE_ASSET__CQGt0rlD__"